import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import dynamic from 'next/dynamic';
import styled from 'styled-components';

import Link from '~/components/Link/Link';
import { connect } from 'react-redux';
import { Nav as UIKitNav } from 'tmt-ui-kit';
import { actions as sessionActions } from '~/redux/reducers/session';
import { actions as filterActions } from '~/redux/reducers/filter';
import Colors from '~/utils/colors';
import { currencies } from '~/utils/helpers.js';
import destinations from '~/experience-destinations.json';
import Router from 'next/router';
// import Scroll from 'react-scroll';
import scrollTo from '~/utils/scroller';
import { getCity } from '~/utils/helpers';
import { path } from '~/utils/media';
import config from '~/config';

// const LogoProvider = dynamic(() => import(/* webpackChunkName: "Partner.LogoProvider.components" */'../Partner/LogoProvider'), { loading: () => null });
// const DesktopNav = dynamic(() => import(/* webpackChunkName: "Nav.DesktopNav.components" */'./DesktopNav'), { loading: () => null });
// const MobileNav = dynamic(() => import(/* webpackChunkName: "Nav.MobileNav.components" */'./MobileNav'), { loading: () => null });

const optionDestinations = Object.keys(destinations).map(key => {
  const optionItem = destinations[key].map(option => ({ value: JSON.stringify(option), label: option.label }));
  return {
    group: key,
    items: optionItem,
  };
});

const services = JSON.parse('[{"label":"4G Sim Card","url":"/trip/happy-tourist-sim-card-8-days"},{"label":"Airport - Hotel Private Transfer","url":"/article/private-airport-transfers-ferries-van-car-rentals"},{"label":"Airport Luggage","url":"/article/luggage-deposit-and-delivery-services"},{"label":"Attraction Ticket","url":"/article/thailand-attraction-ticket-travel-product"},{"label":"Spa Treatment / Massage","url":"/ticket/perception-blind-massage-in-bangkok"},{"label":"Private Tuk-Tuk Rides","url":"/trip/1-day-unlimited-private-tuk-tuk-rides-bangkok-old-town"},{"label":"1-Day Chao Phraya Boat Pass","url":"/ticket/1-day-pass-chao-phraya-hop-on-hop-off-boat"},{"label":"Bangkok Hop-on Hop-off Bus Tour","url":"/ticket/20-off-elephant-go-go-hop-on-hop-off-bus-tour"}]');

const optionServices = services.map((option) => ({
  label: option.label,
  value: JSON.stringify(option),
}));

// const serviceOptions = [
//   { label: 'Thailand 4G SIM Card', value: '/trip/happy-tourist-sim-card-8-days' },
//   { label: 'Up to 50% OFF Attraction Tickets', value: '/article/thailand-attraction-ticket-travel-product' },
//   { label: 'Private Airport Transfer & Car Rental with Driver', value: '/article/private-airport-transfers-ferries-van-car-rentals' },
//   { label: 'Spa & Massage', value: '/ticket/perception-blind-massage-in-bangkok' },
// ];

const Container = styled.div`
  ${props => !props.isPartner && 'position: fixed;'}
  width: 100%;
  z-index: 4000;
  background: ${Colors.white};
  transition: top 0.5s ease-in-out;
`;

const enhance = connect(
  state => ({
    sessionData: state.session.data,
    isLoggedIn: state.session.isLoggedIn,
    user: state.session.user,
    notifications: state.session.notifications,
    isNotification: state.session.isNotification,
    isOpenMobileMenu: state.session.isOpenMobileMenu,
    isOpenLogin: state.session.isOpenLogin,
    toasts: state.toast.toasts,
    isGDPR: state.app.isGDPR,
    isSessionDataLoaded: state.session.isSessionDataLoaded,
    locale: 'en',
    seenZone: state.home.seenZone,
    isPartner: state.app.isPartner,
    affid: state.app.affid,
    partnerConfig: state.app.partnerConfig,
  }), {
    ...sessionActions,
    logFilterActivity: filterActions.logFilterActivity,
  }
);

class Nav extends Component {
  static propTypes = {
    // isWhite: PropTypes.bool,
    // hideMenu: PropTypes.bool,
    // fullWidth: PropTypes.bool,
    // isOpenMobileMenu: PropTypes.bool,
    // locale: PropTypes.string,
    isGDPR: PropTypes.bool,
    url: PropTypes.any,
    sessionData: PropTypes.object,
    // clickCall: PropTypes.func,
    openLogin: PropTypes.func,
    openSignup: PropTypes.func,
    setSessionData: PropTypes.func,
    clickCall: PropTypes.func,
    isSessionDataLoaded: PropTypes.bool,
    logFilterActivity: PropTypes.func,
    // openMobileMenu: PropTypes.func,
    // toasts: PropTypes.array,
    isLoggedIn: PropTypes.bool,
    isNotification: PropTypes.bool,
    user: PropTypes.object,
    notifications: PropTypes.object,
    seenZone: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.onChangeCurrency = this.onChangeCurrency.bind(this);
    this.getLabel = this.getLabel.bind(this);
    this.onChangeDestination = this.onChangeDestination.bind(this);
    this.clickCall = this.clickCall.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.isSessionDataLoaded !== nextProps.isSessionDataLoaded) {
      return true;
    }
    if (this.props.isLoggedIn !== nextProps.isLoggedIn) {
      return true;
    }
    if (this.props.sessionData.currency !== nextProps.sessionData.currency) {
      return true;
    }
    if (this.props.isNotification !== nextProps.isNotification) {
      return true;
    }
    if (this.props.user !== nextProps.user) {
      return true;
    }
    if (this.props.notifications !== nextProps.notifications) {
      return true;
    }
    if (this.props.isGDPR !== nextProps.isGDPR) {
      return true;
    }
    if (this.props.seenZone !== nextProps.seenZone) {
      return true;
    }
    if ((this.props.url.pathname !== nextProps.url.pathname)) {
      return true;
    }
    return false;
  }

  onChangeCurrency(e) {
    e.target.blur();
    this.props.setSessionData({ currency: e.target.value }, true);
  }

  onChangeDestination(e) { // eslint-disable-line
    const { pathname, query, url } = JSON.parse(e.target.value);

    const location = 'Navbar Where To Go Filter Menu';
    this.props.logFilterActivity(location, query.city, '');
    Promise.resolve(Router.push({
      pathname,
      query: {
        ...query,
        fullPath: url,
      }
    }, url))
      .then(() => {
        if (typeof window !== 'undefined' && window && window.scrollTo) {
          window.scrollTo(0, 0);
        }
      });
  }
  // onChangeService,
  // selectedService,
  // otherServices,
  onChangeService = (e) => { // eslint-disable-line
    // const { pathname, query, url } = JSON.parse(e.target.value);
    // const location = 'Navbar Travel Products Menu';
    // this.props.logFilterActivity(location, query.city, '');
    // Promise.resolve(Router.push({
    //   pathname,
    //   query: {
    //     ...query,
    //     fullPath: url,
    //   }
    // }, url))
    //   .then(() => {
    //     if (typeof window !== 'undefined' && window && window.scrollTo) {
    //       window.scrollTo(0, 0);
    //     }
    //   });
    const { url } = JSON.parse(e.target.value);
    Router.push(url);
  }

  // onChangeDestination = (e) => { // eslint-disable-line
  //   const { pathname, query, url } = JSON.parse(e.target.value);
  //   Promise.resolve(Router.push({
  //     pathname,
  //     query: {
  //       ...query,
  //       fullPath: url,
  //     }
  //   }, url))
  //     .then(() => {
  //       if (typeof window !== 'undefined' && window && window.scrollTo) {
  //         window.scrollTo(0, 0);
  //       }
  //     });
  // }

  onSelectService = (e) => {
    Router.push({
      pathname: e.target.value,
    }, e.target.value);
  }

  getLabel() {
    const { url } = this.props;
    const city = (url && url.query && url.query.city) || null;
    if (city) return getCity(city);
    return 'Where to go?';
  }

  getLabelService() {
    const { url } = this.props;
    const city = (url && url.query && url.query.city) || null;
    if (city) return getCity(city);
    return 'Travel Products';
  }

  getActivePage() {
    const { url, seenZone } = this.props;
    const { pathname } = url;
    if (pathname !== '/home') {
      switch (pathname) {
        case '/article/article':
          return 'travel-guides';
        default:
          return pathname.replace('/', '');
      }
    }
    const element = Object.keys(seenZone).find(key => seenZone[key]);
    return element || '';
  }

  getPartnerLogos = () => {
    const { query = {} } = this.props.url;
    const {
      preview_logo_desktop: previewLogoDekstop,
      preview_logo_desktop2x: previewLogoDekstop2x,
      preview_logo_mobile: previewLogoMobile,
      preview_logo_mobile2x: previewLogoMobile2x,
    } = query;

    if (previewLogoDekstop || previewLogoDekstop2x || previewLogoMobile || previewLogoMobile2x) {
      return {
        ...(previewLogoDekstop ? { desktop: path(previewLogoDekstop) } : {}),
        ...(previewLogoDekstop2x ? { desktop2x: path(previewLogoDekstop2x) } : {}),
        ...(previewLogoMobile ? { mobile: path(previewLogoMobile) } : {}),
        ...(previewLogoMobile2x ? { mobile2x: path(previewLogoMobile2x) } : {}),
        alt: '',
      };
    }

    if (this.props.partnerConfig && this.props.partnerConfig.logos) {
      return this.props.partnerConfig.logos;
    }

    return undefined;
  }

  clickCall() {
    this.props.clickCall();
  }

  render() {
    const { sessionData, url, user, notifications, affid } = this.props;
    const selectedDestination = this.getLabel();
    const selectedService = this.getLabelService();
    const page = this.getActivePage();
    const scrollChoice = url.pathname === '/home'
      ? <a onClick={() => scrollTo('other-services', { offset: -100, duration: 1600, smooth: true, })} />
      : <Link to="/" query={{ scrollTo: 'other-services' }} />;
    const affiliateId = url.query.affid || affid || undefined;
    const isTGTHAffiliate = affiliateId === config.tgthAffiliateId;
    const isTGTHUser = !!user.tgth_uuid;
    const hideMainMenus = isTGTHAffiliate || isTGTHUser;
    const centerLogoOnMobile = isTGTHAffiliate || isTGTHUser;
    const alwaysHidePoweredByLogo = isTGTHAffiliate || isTGTHUser;
    const alwaysHideSupportButton = isTGTHAffiliate || isTGTHUser;
    const showBackButton = isTGTHAffiliate || isTGTHUser;
    return (
      <Container isGDPR={this.props.isGDPR}>
        <UIKitNav.Navbar
          hideMenu={!this.props.isSessionDataLoaded}
          // Dropdown Travels
          selectedDestination={selectedDestination}
          optionDestinations={optionDestinations}
          placeholder="Where to go ?"
          onChangeDestination={this.onChangeDestination}

          // Travel Products (Other Services)
          otherServices={optionServices}
          selectedService={selectedService}
          onChangeService={this.onChangeService}

          // Dropdown Currency
          optionCurrencies={currencies}
          selectedCurrency={sessionData.currency}
          currencyLabel={sessionData.currency}
          onChangeCurrency={this.onChangeCurrency}

          // Link button
          logoButtonContainer={<Link to="/" />}
          onClickSignup={() => this.props.openSignup()}
          onClickLogin={() => this.props.openLogin()}
          isLoggedIn={this.props.isLoggedIn}
          user={{ ...user, ...notifications }}
          navLink={{
            editProfile: <Link to="/dashboard/profile" />,
            signUp: <a onClick={() => this.props.openSignup()} />,
            logIn: <a onClick={() => this.props.openLogin()} />,
            dashboard: <Link to="/dashboard" />,
            wishlist: <Link to="/dashboard?section=wishlist" />,
            trustAndSafety: <Link to="/trust-and-safety" />,
            bookings: <Link to="/dashboard/booking" />,
            message: <Link to="/dashboard/booking" />,
            addOns: <Link to="/dashboard/service" />,
            getFreeTrip: <Link to="/dashboard/referral" />,
            deals: <Link to="/promotions" />,
            helpCenter: <Link to="/help-center" />,
            verification: <Link to="/dashboard/verification" />,
            logOut: <Link to="/logout" />,
            contact: <Link to="/contact" />,
            travelGuides: <Link to="/article" />,
            listing: this.props.user.is_local_expert ? <Link to="/dashboard/listing" /> : <a href="/local-expert-benefits" />,
            otherServices: scrollChoice,
            wallet: <Link to="/dashboard/wallet" />,
            availability: <Link to="/dashboard/availability" />,
            findTrips: <Link to="/explore/Bangkok" />,
            setting: <Link to="/dashboard/settings" />,
            community: <Link to="/local-expert-community" target="_blank" rel="noopener noreferrer" />,
          }}
          socialLink={{
            faceBookLink: <a href="https://www.facebook.com/Takemetour/" target="_blank" rel="noopener noreferrer" />,
            instagramLink: <a href="https://www.instagram.com/takemetour_thailand/" target="_blank" rel="noopener noreferrer" />,
            pinterestLink: <a href="https://www.pinterest.com/TakeMeTour/" target="_blank" rel="noopener noreferrer" />,
          }}
          whatAppsButtonContainer={<a href="https://api.whatsapp.com/send?phone=66830761452" onClick={this.clickCall} />}
          page={page}
          messageCount={(notifications && notifications.messageCount) || 0}
          bookingCount={(notifications && notifications.bookingCount) || 0}
          // Gdpr baner
          isGDPR={this.props.isGDPR}
          affiliateDetail={this.getPartnerLogos()}
          hideMainMenus={hideMainMenus}
          centerLogoOnMobile={centerLogoOnMobile}
          alwaysHidePoweredByLogo={alwaysHidePoweredByLogo}
          alwaysHideSupportButton={alwaysHideSupportButton}
          showBackButton={showBackButton}
          onBackButtonClick={Router.back}
        />
      </Container>
    );
  }
}

export default enhance(Nav);
